import { dataSmileyComment } from 'dls-icons-data'
import { createIcon } from '../common'

const IconSmileyComment = /*#__PURE__*/createIcon(dataSmileyComment)
export default IconSmileyComment
